export default class Header {
  constructor() {
    this.navTrigger = document.querySelector('#nav-trigger');
    this.navContainer = document.querySelector('header .right');
    this.navTrigger.addEventListener(
      'click',
      this.showOrHideMenu.bind(this, null)
    );
  }
  showOrHideMenu(status) {
    this.menuShown = status != null ? status : !this.menuShown;

    if (this.menuShown) {
      this.navTrigger.classList.add('active');
      this.navContainer.classList.add('active');
    } else {
      this.navTrigger.classList.remove('active');
      this.navContainer.classList.remove('active');
    }
  }
}
